// extracted by mini-css-extract-plugin
export default {"image":"AddResultDisabledUserScreen_image__GIHlo","body":"AddResultDisabledUserScreen_body__7n75V"};